import { render, staticRenderFns } from "./TransactionCompleted.vue?vue&type=template&id=45d73f78&scoped=true"
import script from "./TransactionCompleted.vue?vue&type=script&lang=js"
export * from "./TransactionCompleted.vue?vue&type=script&lang=js"
import style0 from "./TransactionCompleted.vue?vue&type=style&index=0&id=45d73f78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d73f78",
  null
  
)

export default component.exports